class App {
	constructor() {
		this.init();
	}

	init() {
		window.addEventListener("DOMContentLoaded", () => {
			console.log("App initialized");

			const navButton = document.querySelector(".mobile.icon");

			navButton.addEventListener("click", () => {
				navButton.classList.toggle("active");

				const menu = document.querySelector(".menus");
				menu.classList.toggle("active");
			});
		});
	}
}
export default App;
